import React from 'react';

import Slider from 'react-slick';
import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';
import useValueForCurrentViewPort from '../../../helpers/useValueForCurrentViewPort';
import { DEFAULT_LANGUAGE } from '../../../config/constants';


import {
  CoreLink,
} from '../../../components';

import './style.scss';

const ViewPartner = ({ entities }) => {
  const centerPadding = useValueForCurrentViewPort('20%', '5%', '4%', '12%', '12.5%');
  const itemsToShow = useValueForCurrentViewPort(2, 6, 8, 8, 8);


  /**
   * @example
   * @param props
   */
  function NextArrow(props) {
    const { onClick } = props;
    return (
      <div
        className="ViewPartner__next"
        onClick={onClick}
      />
    );
  }

  /**
   * @example
   * @param props
   */
  function PrevArrow(props) {
    const { onClick } = props;
    return (
      <div
        className="ViewPartner__prev"
        onClick={onClick}
      />
    );
  }

  const settings = {
    infinite: true,
    slidesToShow: itemsToShow,
    speed: 1500,
    autoplay: true,
    centerMode: true,
    centerPadding: centerPadding,
    touchMove: false,
    autoplaySpeed: 3000,
    accessibility: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className="ViewPartner">
      <Slider {...settings}>
        { entities.map((item, index) => {
          return (
            <CoreLink to={item.getIn(['paths', DEFAULT_LANGUAGE])} key={item.getIn(['uuid', 0, 'value'])}>
              <div className="ViewPartner__item_wrapper">
                <div className="ViewPartner__flex">
                  <Image
                    src={item.getIn(['field_image', 0, 'styles', 'partner_slider_teaser'])}
                    alt={item.getIn(['field_title', 0, 'value'])}
                    className="ViewPartner__slide"
                    includeWebP
                  />
                </div>
              </div>
            </CoreLink>
          );
        })}
      </Slider>
    </div>
  );
};

export default ViewPartner;
